export const messages = {
  en: {
    shopAccount: {
      title: 'Account',
      accountId: 'Account ID',
      accountName: 'Account Name',
      accountType: 'Account Type',
      accountAmount: 'Amount',
      createTime: 'Create Time',
      operations: 'Operations',
      withdraw: 'Withdraw',
      withdrawalTitle: 'Account Withdrawal',
      withdrawalAmount: 'Withdrawal Amount',
      bank: 'Bank',
      applicationNote: 'Application Note',
      cancel: 'Cancel',
      confirm: 'Confirm'
    }
  },
  zh: {
    shopAccount: {
      title: '账户',
      accountId: '账户编号',
      accountName: '账户名称',
      accountType: '账户类型',
      accountAmount: '账户金额',
      createTime: '创建时间',
      operations: '操作',
      withdraw: '提现',
      withdrawalTitle: '账户提现',
      withdrawalAmount: '提现金额',
      bank: '开户行',
      applicationNote: '申请说明',
      cancel: '取消',
      confirm: '确定'
    }
  }
}